<form [formGroup]="contactDetailsForm">
  <ion-list lines="full" class="ion-no-margin">
    <ion-item>
      <ion-input [label]="'components.contact-details.givenName' | translate" labelPlacement="stacked" formControlName="givenName" [placeholder]="'components.contact-details.givenName' | translate" autocapitalize="on" [disabled]="authenticated"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input [label]="'components.contact-details.surname' | translate" labelPlacement="stacked" formControlName="surname" [placeholder]="'components.contact-details.surname' | translate" autocapitalize="on" [disabled]="authenticated"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">{{ 'components.contact-details.dateOfBirth' | translate }}</ion-label>
      <ion-datetime [value]="contactDetailsForm.value.dateOfBirth" (ionChange)="updateDateOfBirth($event)" display-format="DD.MM.YYYY" picker-format="DD.MM.YYYY"></ion-datetime>
    </ion-item>
    <ion-item>
      <ion-input [label]="'components.contact-details.street' | translate" labelPlacement="stacked" formControlName="street" [placeholder]="'components.contact-details.street' | translate" autocapitalize="on"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input [label]="'components.contact-details.houseNumber' | translate" labelPlacement="stacked" formControlName="houseNumber" [placeholder]="'components.contact-details.houseNumber' | translate"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input [label]="'components.contact-details.zipCode' | translate" labelPlacement="stacked" inputmode="numeric" formControlName="zipCode" [placeholder]="'components.contact-details.zipCode' | translate"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input [label]="'components.contact-details.city' | translate" labelPlacement="stacked" formControlName="city" [placeholder]="'components.contact-details.city' | translate" autocapitalize="on"></ion-input>
    </ion-item>

    <ion-item lines="none">
      <ion-input
        [label]="'components.contact-details.phoneNumber' | translate"
        labelPlacement="stacked"
        type="tel"
        [placeholder]="'components.contact-details.phoneNumberPlaceholder' | translate"
        formControlName="phoneNumber"
      ></ion-input>
    </ion-item>
  </ion-list>

  <ng-content select="[disclaimer]"></ng-content>

  <ion-button [disabled]="!contactDetailsForm.valid" expand="block" (click)="emitSave()">{{ buttonText }}</ion-button>
</form>
